export const resetPasswordRoutesName = {
    resetPassword: "reset-password",
};
